var _g, _ellipse, _ellipse2, _ellipse3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBackgroundDownload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 579,
  height: 188,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#background-download_svg__a)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 70.051,
  cy: 46.509,
  fill: "#FCB115",
  rx: 70.051,
  ry: 46.509,
  transform: "matrix(.98025 .19775 -.5169 .85604 109.07 14)"
}))), /*#__PURE__*/React.createElement("g", {
  filter: "url(#background-download_svg__b)",
  style: {
    mixBlendMode: "lighten"
  }
}, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 61.159,
  cy: 40.623,
  fill: "#E96DA2",
  rx: 61.159,
  ry: 40.623,
  transform: "matrix(.98025 .19775 -.5169 .85604 153.445 74.346)"
}))), /*#__PURE__*/React.createElement("g", {
  filter: "url(#background-download_svg__c)",
  style: {
    mixBlendMode: "screen"
  }
}, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 92.389,
  cy: 61.15,
  fill: "#00CDDA",
  rx: 92.389,
  ry: 61.15,
  transform: "matrix(.98025 .19775 -.5169 .85604 304.867 39.768)"
}))), /*#__PURE__*/React.createElement("g", {
  filter: "url(#background-download_svg__d)",
  style: {
    mixBlendMode: "screen"
  }
}, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 72.353,
  cy: 47.351,
  fill: "#E96DA2",
  rx: 72.353,
  ry: 47.351,
  transform: "matrix(.98025 .19775 -.5169 .85604 188.391 32.42)"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "background-download_svg__a",
  width: 305.547,
  height: 244.332,
  x: 0.922,
  y: -54.5,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_7451_180516",
  stdDeviation: 40
})), /*#__PURE__*/React.createElement("filter", {
  id: "background-download_svg__b",
  width: 363.806,
  height: 310.384,
  x: 10.495,
  y: -33.977,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_7451_180516",
  stdDeviation: 59.182
})), /*#__PURE__*/React.createElement("filter", {
  id: "background-download_svg__c",
  width: 428.626,
  height: 347.646,
  x: 149.511,
  y: -63.438,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_7451_180516",
  stdDeviation: 59.182
})), /*#__PURE__*/React.createElement("filter", {
  id: "background-download_svg__d",
  width: 386.83,
  height: 322.722,
  x: 41.425,
  y: -74.098,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_7451_180516",
  stdDeviation: 59.182
})))));
export default SvgBackgroundDownload;